import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Paper,
  Avatar,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff, Email, Lock, Login } from "@mui/icons-material";
import Logo from "../images/jnplogo.png";
import {
  CandidateLoginAction,
  getPrimaryResumeDetailsAction,
  saveUserDataAction,
  getCompanyPackageDataAction,
  updatePackageAlertLogAction,
} from "../redux/action";
import { userSelector } from "../user-redux/selector";
import MetaTags from "react-meta-tags";
import { appSelector } from "../redux/selector";

import Key from "../../clientVariables.json";
import axios from "axios";
import { toast } from "react-toastify";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector(userSelector);
  const { loginCandidate } = useSelector(appSelector);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [candidateId, setCandidateid] = useState("");
  const [candidateIdError, setCandidateIdError] = useState("");
  const [candidatelogin, setcandidateLogin] = useState(0);
  const [isCheckingPackage, setIsCheckingPackage] = useState(false);



  const handleLogin = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Validation
    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@(?!gmail\.com|outlook\.com|icloud\.com|yahoo\.com)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // if (!emailRegex?.test(email)) {
    //   setEmailError("Please enter a valid business email address.");
    //   setIsSubmitting(false);
    //   return;
    // }
    if (!email?.trim()) {
      setEmailError("Email address is required.");
      setIsSubmitting(false);
      return;
    }
    if (!password.trim()) {
      setPasswordError("Password is required.");
      setIsSubmitting(false);
      return;
    }

    let userCredentials = {
      email,
      password,
    };
    setIsCheckingPackage(true);
    const loginResponse = await dispatch(
      saveUserDataAction(userCredentials, "RecruiterLogin")
    );

    if (loginResponse && loginResponse.user) {
      const userData = loginResponse.user;
      const packageDataResponse = await dispatch(
        getCompanyPackageDataAction({
          company_id: userData.companyid,
          user_id: userData.id,
        })
      );

      if (packageDataResponse && packageDataResponse.success === 1 && packageDataResponse.data?.showAlert) {
        // Data is now handled in Redux and will be shown on the dashboard
      }
    }

    setIsCheckingPackage(false);
    setIsSubmitting(false);
  };

  const HandleCandidateLogin = async (e) => {
    // alert("func")
    e.preventDefault();
    setIsSubmitting(true);

    if (!candidateId?.trim()) {
      setCandidateIdError("Candidate ID is required.");
      setIsSubmitting(false);
      return;
    }
    if (!password?.trim()) {
      setPasswordError("Password is required.");
      setIsSubmitting(false);
      return;
    }

    let userCredentials = {
      candidateId,
      password,
    };
    const response = await dispatch(
      saveUserDataAction(userCredentials, "CandidateLogin")
    );
    //  if(login === 'login_failed'){
    //   setIsSubmitting(false);
    //
    // if(response.user?.candidate_id){
    //   alert("called")
    //   setIsSubmitting(false);
    //   navigate('/candidateslist');
    // }

    setIsSubmitting(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (candidatelogin === 1) {
      await HandleCandidateLogin(e);
    } else {
      handleLogin(e);
    }
  };

  useEffect(() => {
    if (isCheckingPackage) return;
    if (user?.id && user?.usertype == 3) {
      navigate("/");
    } else if (user && user?.usertype == 6) {
      navigate("/candidate-dashboard");
    } else if (user && (user?.usertype == 7 || user?.usertype == 13)) {
      navigate("/admin-dashboard");
    }
  }, [user, isCheckingPackage]);
  useEffect(() => {
    if (user?.candidate_id) {
      const updateDetails = {
        candidate_id: user?.candidate_id,
      };
      dispatch(getPrimaryResumeDetailsAction(updateDetails));
    }
  }, [user]);

  useEffect(() => {
    fetch(`https://bsapi.jobsnprofiles.com/common/get_notifications`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: 478506,
      }),
    })
      .then((response) => response.json())
      .then((resdata) => {
        console.log(resdata);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const forgotPassword = async () => {
    if (email) {
      try {
        const response = await axios.post(`${Key.domain}/common/forgotpassword_mail`, { email: email });
        if (response.status === 200) {
          toast.success("Check Your email to update password");
        }
      } catch (error) {
        toast.error("Something went wrong..");
      }
    } else {
      toast.error("Invalid email.");
    }
  }


  return (
    <div>
      <MetaTags>
        <title>
          {" "}
          JobsnProfiles Benchsales Recruiting: Login to Your Account
        </title>
        <meta
          name="description"
          content=" Securely Access Your JobsnProfiles Benchsales Recruiting Account.

   "
        />
      </MetaTags>
      <Container
        component="main"
        maxWidth="xs"
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          elevation={3}
          style={{
            padding: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: "5px",
            // boxShadow: "0 3px 5px rgba(0, 0, 0, 0.3)",
          }}
        >
          <Avatar
            src={Logo}
            style={{ width: 70, height: 70, marginBottom: 1 }}
          />

          <form onSubmit={handleSubmit} style={{ width: "100%", marginTop: 1 }}>
            {candidatelogin === 1 ? (
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Candidate Id"
                type="number"
                value={candidateId}
                onChange={(e) => {
                  setCandidateid(e.target.value);
                  setCandidateIdError("");
                }}
                required
                error={!!candidateIdError}
                helperText={candidateIdError}
              />
            ) : (
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Email address"
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setEmailError("");
                }}
                required
                error={!!emailError}
                helperText={emailError}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Email style={{ color: '#1976D2' }} />
                    </InputAdornment>
                  ),
                }}
              />
            )}

            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              error={!!passwordError}
              helperText={passwordError}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock style={{ color: '#1976D2' }} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff style={{ color: '#1976D2' }} /> : <Visibility style={{ color: '#1976D2' }} />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                  color="primary"
                />
              }
              label="Remember me"
            />
            {/* {
            candidatelogin === 1  ? (
              <Button
              type="submit"
              fullWidth
              variant="contained"
              style={{
                margin: "20px 0",
                backgroundColor: "#1976D2",
                color: "white",
              }}
            >
              {isSubmitting ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Sign In"
            )}
              
            </Button>
            ) : 
            <Button
            type="submit"
            fullWidth
            variant="contained"
            style={{
              margin: "20px 0",
              backgroundColor: "#1976D2",
              color: "white",
            }}
          >
            {isSubmitting ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Sign In"
          )}
            
          </Button>
          } */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              style={{
                margin: "20px 0",
                backgroundColor: "#1976D2",
                color: "white",
              }}
              startIcon={<Login />}
            >
              {isSubmitting ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Sign In"
              )}
            </Button>
            <Typography
              variant="body2"
              sx={{
                marginTop: 0, cursor: "pointer",
                "&:hover": {
                  color: 'blue',
                }
              }}
              color="textSecondary"
              align="center"
              onClick={forgotPassword}
            >
              Forgot Password
            </Typography>
          </form>

          {/* {
            candidatelogin === 0 ?
              // <Typography
              //   variant="body2"
              //   color="textSecondary"
              //   align="center"
              //   style={{ marginTop: 20,cursor:"pointer",textDecoration:"underline" }}
              //   onClick={() => {setcandidateLogin(1)  ;setCandidateid("");setPassword("")} }
              // >
              //   Login as a Candidate
              // </Typography> :
              // <Typography
              //   variant="body2"
              //   color="textSecondary"
              //   align="center"
              //   style={{ marginTop: 20, cursor: "pointer", textDecoration: "underline" }}
              //   onClick={() => setcandidateLogin(0)}
              // >
              //   Login as a Recruiter
              // </Typography>

        } */}

          {/* Copyright notice */}
          <Typography
            variant="body2"
            color="textSecondary"
            align="center"
            style={{ marginTop: 20 }}
          >
            &copy; {new Date().getFullYear()} JobsnProfiles. All Rights Reserved.
          </Typography>
        </Paper>
      </Container>

    </div>
  );
};

export default LoginPage;
